import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  titleBox: { margin: '10px' },
  qoutesDatagrid: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
  },
  selectedQuoteDatagrid: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
  },
  quoteTitleBox: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px',
    alignItems: 'center'
  },
  quoteBoxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingRight: '10px'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      '& .makeStyles-dialogTitle-21': {
        padding: '4px 8px !important',
      }
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
}));

export default styles;
